import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Building2, ExternalLink } from 'lucide-react'
import styles from './PublishedPrivateProjectCard.module.scss'

export type PublishedPrivateProjectCardProps = {
  proyectoId: string
  obraName: string
  subproyectoCount: number
}

const PublishedPrivateProjectCard: React.FC<PublishedPrivateProjectCardProps> = ({
  proyectoId,
  obraName,
  subproyectoCount
}) => {
  const navigate = useNavigate()
  const title = obraName.trim() || 'Tu obra'
  const rubrosLine =
    subproyectoCount === 1 ? '1 rubro publicado' : `${subproyectoCount} rubros publicados`

  return (
    <div className={styles.publishedCard}>
      <div className={styles.publishedRow}>
        <div className={styles.publishedPreview}>
          <div className={styles.publishedIconWrap} aria-hidden>
            <Building2 size={28} strokeWidth={1.75} className={styles.publishedIcon} />
          </div>
          <div className={styles.publishedInfo}>
            <span className={styles.publishedBadge}>Obra publicada</span>
            <span className={styles.publishedName}>{title}</span>
            <span className={styles.publishedMeta}>{rubrosLine}</span>
          </div>
        </div>
        <div className={styles.publishedActions}>
          <button
            type="button"
            className={styles.publishedBtn}
            onClick={() => navigate(`/obrasprivadas/${encodeURIComponent(proyectoId)}`)}
            title="Gestioná rubros, datos y cotizaciones de la obra desde la ficha privada."
          >
            <ExternalLink size={14} aria-hidden />
            Ir a la obra
          </button>
        </div>
      </div>
    </div>
  )
}

export default PublishedPrivateProjectCard
